import { createContext, createElement, useContext } from 'react';

/**
 * Mutable head state captured synchronously during render so the SSR
 * prerender can read the per-route <title> and <meta name="description">
 * after renderToString. The client ignores it — usePageTitle applies the
 * values to the document via effects.
 * @typedef {{ current: { title: string | null, description: string | null } }} HeadRef
 */

/** @type {import('react').Context<HeadRef | null>} */
const HeadContext = createContext(/** @type {HeadRef | null} */ (null));

/**
 * @param {{ headRef: HeadRef, children: import('react').ReactNode }} props
 * @returns {import('react').ReactNode}
 */
export function HeadProvider({ headRef, children }) {
	return createElement(HeadContext.Provider, { value: headRef }, children);
}

/**
 * @returns {HeadRef | null}
 */
export function useHead() {
	return useContext(HeadContext);
}
